import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const openMessageModal = (store, {entity, entity_type, context, isReminder, closable, locService}) => {
    closable = closable === false ? false : true
    store.commit(mutations.OPEN_MESSAGE_MODAL, {
        entity, entity_type, context, isReminder, closable, locService
    })
}

export const closeMessageModal = (store) => {
    store.commit(mutations.CLOSE_MESSAGE_MODAL)
}

export const setForceRouteKey = (store, param) => {
    store.commit(mutations.SET_FORCE_ROUTE_KEY, param)
}